import type { KnowledgeItem } from '@/types';

// 注塑成型知识库（10 条）
export const injectionKnowledge: KnowledgeItem[] = [
  {
    id: 'IK001',
    tags: ['注塑', '工艺', '基础', '周期'],
    question: '注塑成型一个完整周期分哪几步？',
    answer: '①合模 → ②注射 → ③保压 → ④冷却（同时计量塑化）→ ⑤开模 → ⑥顶出 → 回到①。一个周期一般 20-40 秒。',
  },
  {
    id: 'IK002',
    tags: ['注射压力', 'inject_pressure', '参数'],
    question: '注射压力多少算合适？',
    answer: '常规工程塑料 70-110 MPa；薄壁件可能要到 130+。压力不够会短射，压力过大易飞边。',
  },
  {
    id: 'IK003',
    tags: ['模具温度', 'mold_temp', '参数'],
    question: '模具温度为啥要稳定？',
    answer: '模温直接影响表面光洁度、结晶度和翘曲。常用 45-75°C，工程塑料部分需要 80-120°C。',
  },
  {
    id: 'IK004',
    tags: ['短射', 'short shot', '故障'],
    question: '短射是什么原因？',
    answer: '熔体没充满型腔。常见：注射压力不足、料温过低、注射速度慢、止逆阀漏。',
  },
  {
    id: 'IK005',
    tags: ['飞边', '毛边', '故障'],
    question: '飞边怎么处理？',
    answer: '锁模力不够、注射压力过大、模具间隙大都会飞边。先检查锁模力是否到位，再看压力。',
  },
  {
    id: 'IK006',
    tags: ['银纹', '气泡', '水气', '故障'],
    question: '银纹和气泡是怎么回事？',
    answer: '主要是物料含水或夹气。含水率 > 400 ppm 一般就会出银纹，加足干燥温度和时间。',
  },
  {
    id: 'IK007',
    tags: ['翘曲', '变形', '故障'],
    question: '翘曲变形怎么办？',
    answer: '模具温度不均、冷却不足、保压不够都会翘曲。检查冷却水流量和模具温度。',
  },
  {
    id: 'IK008',
    tags: ['保压', 'hold pressure', '工艺'],
    question: '保压时间和压力怎么定？',
    answer: '保压填补冷却收缩，一般是注射压力的 60-80%，时间到浇口冻结为止。过长无意义。',
  },
  {
    id: 'IK009',
    tags: ['含水率', '干燥', '工艺'],
    question: '哪些塑料对水敏感？',
    answer: 'PA(尼龙)、PC、PET、ABS 都很怕水，干燥温度 80-120°C，时间 3-6 小时。',
  },
  {
    id: 'IK010',
    tags: ['安全', '操作'],
    question: '注塑机操作有哪些安全注意点？',
    answer: '①开模前确认无人在型腔区；②加料口热！戴手套；③熔体压力高，禁止对喷嘴方向；④清模前先停机断电。',
  },

  // ============================================================
  // v3 新增：6 条新设备 / 工艺知识
  // ============================================================
  {
    id: 'IK011',
    tags: ['模温机', '冷水机', '区别'],
    question: '模温机和冷水机有什么区别？',
    answer: '冷水机走低温（7-25°C）做冷却，模温机走中高温（45-120°C）维持模温。PC、PA 等工程塑料必须用模温机才能成型。',
  },
  {
    id: 'IK012',
    tags: ['取件机械手', '节拍', '配合'],
    question: '机械手取件如何与模具开合配合？',
    answer: '收到"开模到位"信号才进入型腔；抓取后退出 → 模具合模 → 注射开始；典型节拍 4-8 秒，与注塑周期同步。',
  },
  {
    id: 'IK013',
    tags: ['保压', 'V/P 切换', '工艺'],
    question: 'V/P 切换点是什么？',
    answer: 'V/P 切换 = 速度控制切到压力控制的时机。一般在型腔充满 95-98% 时切换，过早短射，过晚飞边。',
  },
  {
    id: 'IK014',
    tags: ['背压', '螺杆', '计量'],
    question: '背压设多少合适？',
    answer: '常规 5-15 MPa。背压低则计量不稳；背压高则剪切热大，料温升高甚至降解。透明料 ABS/PC 一般取 8-12 MPa。',
  },
  {
    id: 'IK015',
    tags: ['冷却时间', '周期', '工艺'],
    question: '冷却时间怎么算？',
    answer: '常用公式 t = h² / (π² × α) × ln(...)，简化经验值：壁厚 1mm 约需 5-8 秒。冷却时间是注塑周期最大头，占总周期 50-70%。',
  },
  {
    id: 'IK016',
    tags: ['上料输送带', '堵料', '故障'],
    question: '上料输送带堵料怎么办？',
    answer: '①立即停机；②查带速和电机电流；③清理卡死颗粒；④检查料斗出口和带子张紧度。强行运转会烧电机。',
  },
];
